import axiosClient from './axiosClient'
const incomeItemApi = {
  findApi: (params) => {
    const url = '/income-item/find'
    return axiosClient.get(url, { params })
  },
  save: (body) => {
    const url = '/income-item/update'
    return axiosClient.post(url, { body })
  },
  delete: (params) => {
    const url = '/income-item/remove'
    return axiosClient.delete(url, { params })
  },
}
export default incomeItemApi
